import * as types from "./actionTypes";
import * as config from "../../../config";
const {getLatestPersonalFootprintByEmail, postPersonalFootprint} = require("@carbonclick/carbon-api-client/src/api/footprintApi");
import { beginApiCall } from "./apiStatusActions";
import { errorHandlerActions } from './errorHandlerActions';
import { extractApiError } from '../../util/errorExtractor'

export function getPersonalFootprintSuccess(footprintData) {
  return { type: types.GET_PERSONAL_FOOTPRINT_SUCCESS, footprintData };
}

export function getPersonalFootprintFailed(error) {
  return { type: types.GET_PERSONAL_FOOTPRINT_FAILED, error };
}

export function getPersonalFootprint(email) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return getLatestPersonalFootprintByEmail(email)
      .then(footprintData => {
        dispatch(getPersonalFootprintSuccess(footprintData));
      })
      .catch(error => {
        const status = extractApiError(error).status;
        if (status !== 404){
          const sentryMessage = `${config.deployment_env} personalFootprintActions.js answers api call error ${JSON.stringify(extractApiError(error))}`;
          dispatch(errorHandlerActions(status, sentryMessage, "fatal"));
        }
        dispatch(getPersonalFootprintFailed(error));
      });
  };
}

export function savePersonalFootprint(email, footprint, answers, footprintOfOneAdult) {
  return function (dispatch) {
    dispatch(beginApiCall());
    return postPersonalFootprint({email, footprint, answers, footprintOfOneAdult})
      .then(() => {
        dispatch(getPersonalFootprintSuccess({email, footprint, answers, footprintOfOneAdult}));
      })
      .catch(error => {
        const status = extractApiError(error).status;
        const sentryMessage = `${config.deployment_env} personalFootprintActions.js footprint api call error ${JSON.stringify(extractApiError(error))}`;
        dispatch(errorHandlerActions(status, sentryMessage, "fatal"));
      });
  };
}
